import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { ProductFormService } from "../shared";

@Component({
  selector: "product-image-with-hot-points-form",
  templateUrl: "./product-image-with-hot-points-form.component.html",
  styleUrls: ["./product-image-with-hot-points-form.component.scss"],
})
export class ProductImageWithHotPointsFormComponent {
  @Input() form: FormGroup;

  constructor(
    public ft: FormToolsService,
    public formService: ProductFormService
  ) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-image-with-hot-points-form/product-image-with-hot-points-form.component.ts